import type * as GeoJSONTypes from 'geojson';

/** Stable stand identity shared by route descriptor builders and map renderers. */
export function featureStandId(feature?: GeoJSONTypes.Feature | null): string {
  if (!feature) return '';
  const id =
    feature.properties?.stand_id ??
    feature.properties?.standId ??
    feature.id ??
    feature.properties?.stand_number;
  return id == null ? '' : String(id);
}
